<template>
  <div id="adm-widget-wrapper">
    <link :href="`${ sourceURL }/embed/app.css?v=06112023`" rel="stylesheet" />
    <div class="adm-widget-init" v-if="!error && !loading">
      <Equipment :data="data" :type="type" :source="sourceURL" :equipment="equipment" v-if="isEquipmentView" />
      <Listing :data="data" :type="type" :source="sourceURL" v-else />
    </div>
    <Loader v-if="loading" />
    <Error v-if="error" />
  </div>
</template>
<style>

</style>
<script>
import Loader from './components/Loader.vue';
import Listing from './components/Listing.vue';
import Equipment from './components/Equipment.vue';
import Error from './components/Error.vue';

export default {
  name: 'App',
  components: {
    Loader,
    Listing,
    Equipment,
    Error
  },
  props: [
    'data',
    'type',
    'staging',
    'source'
  ],
  data() {
    return {
      sourceURL: this.staging ? 'https://adm.dev13.ibc.com.au/testadm' : 'https://www.assetdatamanager.com/adm',
      isEquipmentView: false,
      equipment: 0,
      loading: true,
      error: false
    };
  },
  mounted() {
    this.validateHost();
  },
  methods: {
    async validateHost () {
      var _this = this;
      var hostname = window.location.hostname;

      const valid = await fetch(_this.sourceURL + '/web/verify-domain.aspx?domain=' + hostname + '&c=' + _this.data);
      let host = await valid.json();
      if ( host.Success ) {
        _this.loading = false;
        _this.init();
      }
      else {
        _this.loading = false;
        _this.error = true;
      }

      // setTimeout(function() {
      //   _this.loading = false;
      //   _this.init();
      // }, 3000);
    },
    init () {
      this.sourceURL = (this.source) ? this.source : this.sourceURL;
      
      let urlParams = new URLSearchParams(window.location.search);
      if ( urlParams.has('equipment') ) {
        this.isEquipmentView = true;
        this.equipment = parseInt(urlParams.get('equipment'));
      }
    }
  }
}
</script>
